// SyncPullService

export const FETCH_UPDATES = "FETCH_UPDATES";
export const FETCH_UPDATES_SUCCESS = "FETCH_UPDATES_SUCCESS";
export const FETCH_UPDATES_FAIL = "FETCH_UPDATES_FAIL";

export function fetchUpdates(lastSynced) {
  return {
    type: FETCH_UPDATES,
    payload: {
      request: {
        method: "GET",
        url: "/updates.json",
        params: {
          lastSynced,
        },
      },
    },
  };
}

// SyncPushService

export const SET_PENDING = "SET_PENDING";

export function setPending(data, pending) {
  return {
    type: SET_PENDING,
    data,
    pending,
  };
}

export const SET_SAVED = "SET_SAVED";

export function setSaved(data) {
  return {
    type: SET_SAVED,
    data,
  };
}

export const DELETED_OBJECTS_COMMIT = "DELETED_OBJECTS_COMMIT";

export function deletedObjectsCommit(deleted) {
  return {
    type: DELETED_OBJECTS_COMMIT,
    deleted,
  };
}
